import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import ImportDevices from "../views/backoffice/ImportDevices";
import DeviceEditor from "../views/backoffice/DeviceEditor";
import SimCardEditor from "../views/backoffice/SimEditor";
import ImportSimCards from "../views/backoffice/ImportSimcards";
import DeviceSimPair from "../views/backoffice/DeviceSimPair";
import DeviceList from "../views/backoffice/DeviceList";
import VehicleList from "../views/backoffice/VehicleList";
import SimList from "../views/backoffice/SimList";
import OrderDelivery from "../views/backoffice/OrderDelivery";
import OrderList from "../views/tenant/OrderList";
import OrderEditor from "../views/tenant/OrderEditor";
import CustomersList from "../views/backoffice/CustomersList";
import StoragesList from "../views/backoffice/StoragesList";
import DeviceGis from "../views/backoffice/DeviceGis";
import roles from "../auth/roles";

const Backoffice = () => {

  let { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        key="dashboard"
        path={`${path}/dashboard`}
        exact
        component={() => <h3>Backoffice dashboard here... work in progress!</h3>}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listcustomers"
        path={`${path}/customers`}
        exact
        component={CustomersList}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listdevices"
        path={`${path}/devices`}
        exact
        component={DeviceList}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="gisdevices"
        path={`${path}/gis-devices`}
        exact
        component={DeviceGis}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listsimcards"
        path={`${path}/simcards`}
        exact
        component={SimList}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="importdevices"
        path={`${path}/import-devices`}
        component={ImportDevices}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="importsimcards"
        path={`${path}/import-simcards`}
        component={ImportSimCards}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="adddevice"
        path={`${path}/add-device`}
        component={DeviceEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="editdevice"
        path={`${path}/devices/:id`}
        component={DeviceEditor}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="viewdevice"
        path={`${path}/viewdevice/:id`}
        readOnly
        exact
        component={DeviceEditor}
      />
      <PrivateRoute
        key="addsim"
        path={`${path}/add-sim`}
        component={SimCardEditor}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="editsim"
        path={`${path}/simcards/:id`}
        component={SimCardEditor}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="viewsim"
        path={`${path}/viewsim/:id`}
        readOnly
        exact
        component={SimCardEditor}
      />
      <PrivateRoute
        key="pairdevicesim"
        path={`${path}/devicepairing`}
        component={DeviceSimPair}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="allOrders"
        path={`${path}/orders`}
        isBackOffice
        component={OrderList}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="delivery"
        path={`${path}/create-order-delivery/:id`}
        isBackOffice
        component={OrderDelivery}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="orderEdit"
        path={`${path}/orders/:id`}
        isBackOffice
        component={OrderEditor}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listvehicles"
        path={`${path}/vehicles`}
        isBackOffice
        component={VehicleList}
        exact
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="liststorage"
        path={`${path}/storage`}
        isBackOffice
        component={StoragesList}
        exact
        roles={[roles.ADMIN]}
      />
    </Switch>
  );
};

export default Backoffice;
